import React from 'react';
import { Grid } from '@material-ui/core';
import { ModelForm } from '../components';
import { useParams } from 'react-router-dom';

export default function Transaction({ parentType }) {
	const { childId, transactionId } = useParams();
	return (
		<Grid container>
			<ModelForm
				recordId={transactionId}
				parentId={childId}
				parentType={parentType}
				formName={'transactionForm'}
				hasActions={false}
			/>
		</Grid>
	);
}
